import React from "react";
import {
    Box,
    Card,
    CardBody,
    CardHeader,
    Heading,
    List,
    ListItem,
    SimpleGrid,
    Text,
    VStack,
} from "@chakra-ui/react";
import { brandConfig } from "../../../brandConfig";
import { ADDON_SERVICES } from "../constants/addonServices";

export const AddonsSection: React.FC = () => {
    const cardBg = brandConfig.colors.background.cardGradient;
    const borderColor = brandConfig.colors.border.darkCard;
    const textPrimary = brandConfig.colors.text.inverse;
    const textSecondary = brandConfig.colors.text.secondaryDark;

    return (
        <Box mt={12}>
            <VStack spacing={6} align="stretch">
                <VStack spacing={2} textAlign="center">
                    <Heading size="xl" color={textPrimary}>
                        Power-Up with Add-Ons
                    </Heading>
                    <Text fontSize="md" color={textSecondary}>
                        Enhance any plan with these additional services
                    </Text>
                </VStack>

                <SimpleGrid columns={{ base: 1, md: 2, lg: 3 }} spacing={6}>
                    {ADDON_SERVICES.map((category) => (
                        <Card
                            key={category.category}
                            bg={cardBg}
                            borderColor={borderColor}
                            borderWidth="1px"
                        >
                            <CardHeader>
                                <Heading size="sm" color={textPrimary}>
                                    {category.category}
                                </Heading>
                            </CardHeader>
                            <CardBody>
                                <List spacing={3}>
                                    {category.items.map((item) => (
                                        <ListItem key={item.id}>
                                            <VStack align="start" spacing={0}>
                                                <Text fontSize="sm" color={textPrimary}>
                                                    {item.name}
                                                </Text>
                                                <Text
                                                    fontSize="xs"
                                                    color={brandConfig.colors.primary}
                                                    fontWeight="bold"
                                                >
                                                    {item.price}
                                                </Text>
                                            </VStack>
                                        </ListItem>
                                    ))}
                                </List>
                            </CardBody>
                        </Card>
                    ))}
                </SimpleGrid>
            </VStack>
        </Box>
    );
};
